<template>
  <base-dialog
    v-model="show"
    max-width="700px"
    title="Cập nhật thông tin đối tượng"
    :loading="loading"
    @close="close"
  >
    <v-form ref="form" v-model="valid" lazy-validation class="pa-2">
      <v-container fluid class="pa-0">
        <v-row>
          <v-col
            v-for="field in editableFields"
            :key="field.code"
            cols="12"
            md="6"
            class="py-2"
          >
            <field-group
              v-model="formData[field.code]"
              :label="field.name || field.code"
              :typeInput="getTypeInput(field)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <template #extra-btn>
      <base-button color="primary" :loading="loading" @click="onSubmit">
        Cập nhật
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import fieldGroup from '@components/field/field-group.vue'

export default {
  name: 'FeatureEditDialog',
  components: { fieldGroup },
  props: {
    api: { type: Object, required: true },
  },
  data: () => ({
    show: false,
    loading: false,
    valid: true,
    item: null,
    fields: [],
    formData: {},
  }),
  computed: {
    editableFields() {
      return (this.fields || []).filter(
        (f) =>
          !['geometry', 'array', 'region-field'].includes(f.type) &&
          f.code !== 'version'
      )
    },
  },
  methods: {
    open({ item, fields }) {
      this.item = item
      this.fields = fields || []
      const data = {}
      this.editableFields.forEach((field) => {
        data[field.code] = item ? item[field.code] : undefined
      })
      this.formData = data
      this.show = true
    },
    close() {
      this.show = false
      this.loading = false
    },
    getTypeInput(field) {
      if (['integer', 'number', 'double', 'float'].includes(field.type)) {
        return 'v-text-field'
      }
      if (field.type === 'boolean') {
        return 'v-switch'
      }
      if (field.type === 'date' || field.type === 'datetime') {
        return 'v-text-field'
      }
      return 'v-text-field'
    },
    async onSubmit() {
      if (!this.item || (!this.item.id && this.item.id !== 0)) return
      this.loading = true
      try {
        const res = await this.api.update(this.item.id, this.formData)
        if (res && res.error) {
          this.$store.dispatch('showError', res.message || 'Cập nhật thất bại')
        } else {
          this.$emit('success')
          this.close()
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style scoped></style>
